import type { Fallacy } from "./types";
import { createStory } from "./types";

export const freeRider: Fallacy = {
    id: "free-rider",
    name: "Free Rider Problem",
    emoji: "🛋️",
    category: "Jebakan Strategi",
    description: "\"**Biar orang lain aja** yang usaha\" — rasional tapi **merusak sistem**.",
    tldr: "\"Nggak usah kontribusi, toh hasilnya bisa dinikmati gratis\" — sampai semua orang berpikir sama.",
    detail: "Free Rider Problem terjadi ketika seseorang **menikmati manfaat** dari usaha bersama **tanpa ikut berkontribusi**, berharap orang lain menanggung biayanya. Secara individual tampak rasional — tapi kalau semua berpikir begitu, tidak ada yang berkontribusi dan manfaat bersama hilang.\n\nFree riding bukan sekadar masalah moral — ini jebakan strategis. Ketika beberapa orang free ride dan lolos, yang awalnya mau berkontribusi merasa \"bodoh\". Lama-lama semakin banyak yang berhenti, dan **sistem kolektif runtuh**.\n\nSolusinya: transparansi kontribusi, sanksi sosial, atau sistem di mana manfaat hanya bisa diakses oleh yang berkontribusi.",
    story: createStory("Free Rider Problem", "🛋️", {
      hook: {
        title: "\"Ngapain bayar kalo gratis?\"",
        body: "Iuran RT gak dibayar, toh jalanan tetep bersih. Sampai... semua orang mikir sama.",
      },
      convo: {
        claim: "Iuran RT yang bayar cuma 40%, tapi jalanan tetep bersih. **Ngapain aku bayar kalau tanpa bayar juga jalan** dan hasilnya sama aja.",
        response: "Jalan karena 40% itu nanggung. **Kalau semua mikir kayak kamu, gak ada yang bayar.**",
      },
      reveal: {
        body: "Kamu **nikmatin hasil usaha bersama tanpa ikut kontribusi**, ngarep orang lain yang nanggung biayanya.",
      },
      insight: {
        title: "Efek dominonya",
        body: "Yang bayar ngeliat free rider lolos, mereka ngerasa \"bodoh\". Lama-lama **makin banyak yang berhenti**, dan sistemnya **runtuh buat semua orang**.",
      },
      engagement: {
        title: "Pernah kesel liat orang free ride? 🛋️",
        body: "Iuran RT, tugas kelompok, atau project kantor? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["tragedy-of-commons", "prisoners-dilemma", "sunk-cost"],
  };
